import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-228af6e8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "songer"
};
var _hoisted_2 = ["onClick"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_4 = {
  key: 1,
  class: "none-title"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "没有更多了哦~", -1
  /* HOISTED */
  );
});

var _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return _ctx.songerList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.songerList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "songer-list",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.songerClick(item.id);
      }
    }, [_createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.picUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_3];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createCommentVNode(" 歌手 "), _createElementVNode("p", null, _toDisplayString(item.name), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_2);
  }), 128
  /* KEYED_FRAGMENT */
  ))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6));
}